import {
  IssueTypeDto,
  UpdateIssueTypeRequestDto,
  useApi,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';

export function useUpdateIssueType(): UseMutationResult<
  IssueTypeDto,
  ExtendedAxiosError,
  { id: string } & UpdateIssueTypeRequestDto
> {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<
    IssueTypeDto,
    ExtendedAxiosError,
    { id: string } & UpdateIssueTypeRequestDto
  >({
    mutationKey: ['issue-types'],
    mutationFn: ({ id, ...data }) =>
      api.issueTypesApi.updateIssueType(id, { ...data }).then((r) => r.data),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['users', 'roles'],
        }),
      ]);
    },
  });
}
